import { ILabelSelect } from "../../services/Language/Types";

export const constructSequentialOptions = (start: number, end: number, step: number, text: (val: number) => string): ILabelSelect[] => {
    const n = Math.ceil((end - start + 1)/step);
    return Array(n)
        .fill(start)
        .map((value, index) => ({ value: value + index * step, label: text(value + index * step) }));
}


// WEBPACK FOOTER //
// ./src/components/AdminSetupPage/SettingsOptionsValues.ts